import { render, staticRenderFns } from "./customerPage.vue?vue&type=template&id=d5f91884&"
import script from "./customerPage.vue?vue&type=script&lang=ts&"
export * from "./customerPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports